import get from 'lodash.get';
import { createSelector } from '../../../../utilities/reselect';
import { shouldDisplayOnPage } from '../../../../utilities/bannersAndModals';
import Cookie from '../../../../services/Cookie';

export const getOutageBannerDetails = state => state.outageBanner;

export const getOutageBannerIsEnabled = createSelector(getOutageBannerDetails, outageBannerDetails => {
  const shouldShowOutageBanner = get(outageBannerDetails, 'entities.OutageBanner.isEnabled', false);
  return shouldShowOutageBanner;
});

export const getOutageCookieName = createSelector(getOutageBannerDetails, outageBannerDetails => {
  const outageCookieName = get(outageBannerDetails, 'entities.OutageBanner.outageCookieName', 'OutageBannerCookie');
  return outageCookieName;
});

export const getOutageBannerHeader = createSelector(getOutageBannerDetails, outageBannerDetails => {
  const outageBannerHeader = get(outageBannerDetails, 'entities.OutageBanner.outageHeader', 'Sorry, we are experiencing an outage');
  return outageBannerHeader;
});

export const getOutageBannerDescription = createSelector(getOutageBannerDetails, outageBannerDetails => {
  const outageBannerDescription = get(outageBannerDetails, 'entities.OutageBanner.outageDescription', 'Our tech team is working quickly resolve this issue');
  return outageBannerDescription;
});

export const getOutageExcludedPages = createSelector(getOutageBannerDetails, outageBannerDetails => {
  const outageExcludedPages = get(outageBannerDetails, 'entities.OutageBanner.excludedPages', []);
  return outageExcludedPages;
});

export const getOutageIncludedPages = createSelector(getOutageBannerDetails, outageBannerDetails => {
  const outageExcludedPages = get(outageBannerDetails, 'entities.OutageBanner.includedPages', []);
  return outageExcludedPages;
});

export const getShouldDisplayOutageBannerOnPage = createSelector(
  [getOutageBannerIsEnabled, getOutageCookieName, getOutageIncludedPages, getOutageExcludedPages],
  (isBannerEnabled, cookieName, includedPages, excludedPages) => {
    if (!isBannerEnabled) return false;

    const bannerCookie = Cookie.getCookie(cookieName);
    const bannerCookieValue = JSON.parse(bannerCookie);

    const hasUserDismissedBanner = bannerCookie != null && !bannerCookieValue;
    if (hasUserDismissedBanner) return false;

    const isBannerStartSession = bannerCookie == null && isBannerEnabled;
    if (isBannerStartSession) Cookie.setCookie(cookieName, isBannerEnabled);

    return shouldDisplayOnPage(includedPages, excludedPages);
  }
);
